"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _CtaStatus = require("./constants/CtaStatus");
const CtaButton = ({
  ctaStatus = _CtaStatus.CTA_STATUS.PENDING,
  DefaultCta = () => /*#__PURE__*/_react.default.createElement("div", null, "Default"),
  RunningCta = () => /*#__PURE__*/_react.default.createElement("div", null, "Running"),
  FailedCta = () => /*#__PURE__*/_react.default.createElement("div", null, "Failed"),
  CompletedCta = () => /*#__PURE__*/_react.default.createElement("div", null, "Complete"),
  RevertingCta = () => /*#__PURE__*/_react.default.createElement("div", null, "Reverting")
}) => {
  switch (ctaStatus) {
    case _CtaStatus.CTA_STATUS.PENDING:
      return /*#__PURE__*/_react.default.createElement(DefaultCta, null);
    case _CtaStatus.CTA_STATUS.RUNNING:
      return /*#__PURE__*/_react.default.createElement(RunningCta, null);
    case _CtaStatus.CTA_STATUS.FAILED:
      return /*#__PURE__*/_react.default.createElement(FailedCta, null);
    case _CtaStatus.CTA_STATUS.COMPLETE:
      return /*#__PURE__*/_react.default.createElement(CompletedCta, null);
    case _CtaStatus.CTA_STATUS.REVERTING:
      return /*#__PURE__*/_react.default.createElement(RevertingCta, null);
    default:
      return /*#__PURE__*/_react.default.createElement(DefaultCta, null);
  }
};
CtaButton.propTypes = {
  ctaStatus: _propTypes.default.string,
  DefaultCta: _propTypes.default.func,
  RunningCta: _propTypes.default.func,
  FailedCta: _propTypes.default.func,
  CompletedCta: _propTypes.default.func,
  RevertingCta: _propTypes.default.func
};
var _default = exports.default = CtaButton;